/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A3Inputs */

const en_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutely. You can cancel your subscription anytime from your account settings. No cancellation fees.`)
};

const de_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbstverstaendlich. Sie koennen Ihr Abonnement jederzeit in Ihren Kontoeinstellungen kuendigen. Keine Kuendigungsgebuehren.`)
};

const fr_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const es_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const it_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const nl_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const pl_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const fi_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const da_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

const sv_pricing_faq_a3 = /** @type {(inputs: Pricing_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, you can cancel your subscription at any time from your account settings. You will keep access to all paid features until the end of your current billing period.`)
};

/**
* | output |
* | --- |
* | "Absolutely. You can cancel your subscription anytime from your account settings. No cancellation fees." |
*
* @param {Pricing_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a3 = /** @type {((inputs?: Pricing_Faq_A3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a3(inputs)
	if (locale === "fr") return fr_pricing_faq_a3(inputs)
	if (locale === "es") return es_pricing_faq_a3(inputs)
	if (locale === "it") return it_pricing_faq_a3(inputs)
	if (locale === "nl") return nl_pricing_faq_a3(inputs)
	if (locale === "pl") return pl_pricing_faq_a3(inputs)
	if (locale === "fi") return fi_pricing_faq_a3(inputs)
	if (locale === "da") return da_pricing_faq_a3(inputs)
	if (locale === "sv") return sv_pricing_faq_a3(inputs)
	return en_pricing_faq_a3(inputs)
});